import axios from 'axios'
import { HTTP_BASEURL, HTTP_TIMEOUT } from '../conf/service'
import store from '../redux'
import {
    SigninPage,
    ScheduleRemindPage,
    SignupPage,
    Reset,
    ScheduleRemindDetailPage,
} from '../conf/routePath'
axios.defaults.timeout = HTTP_TIMEOUT
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = HTTP_BASEURL

const { pathname } = window.location
const notAuth = [
    SigninPage,
    SignupPage,
    Reset,
    ScheduleRemindPage,
    ScheduleRemindDetailPage,
]
// 请求拦截
axios.interceptors.request.use(
    (config) => {
        // 请求之前，从缓存中读取token信息，放入请求头
        const { userInfo } = store.getState()
        // console.log('userInfo', userInfo)
        if (userInfo) {
            config.headers.Authorization = userInfo.access_token
            const expires = userInfo.expires
            const now = Date.parse(new Date() as any) / 1000 - 60

            if (expires < now && pathname !== ScheduleRemindPage) {
                window.location.replace(SigninPage)
                return {}
            }
        } else {
            if (notAuth.indexOf(pathname) === -1) {
                window.location.replace(SigninPage)
            }
        }
        return config
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)
// 响应拦截
axios.interceptors.response.use(
    (response) => {
        const { data } = response
        return data
    },
    (error) => {
        const { response, config } = error
        if (!response) {
            return Promise.reject()
        }
        // 登录超时
        if (response.status === 403 || response.status === 401) {
            // console.log(response, config)
            if (pathname === ScheduleRemindPage) {
                return Promise.reject(response)
            }
            if (config.url.indexOf('register') === -1) {
                window.location.replace(SigninPage)
            } else {
                return Promise.reject(response)
            }
        } else {
            return Promise.reject(response.data)
        }
    }
)

export default axios
